module.exports = __webpack_public_path__ + "assets/img/chongQingBrother.9ffd7299.png";